import React from "react";
import { Grid, Tab } from "semantic-ui-react";
import { useSelector } from "react-redux";
import { getAdmin, getCompanyProfilesForReview } from "../adminSelectors";
import CompanyProfileListItem from "./CompanyProfileListItem";
import { COMPANY_PROFILE_TYPE } from "../adminConstants";

export default function ReviewCompanyProfiles() {
  const { companyProfiles } = useSelector((state) => getAdmin(state));

  const itemsToReview = getCompanyProfilesForReview(companyProfiles);

  const REVIEW_TAB = (
    <Grid>
      <Grid.Column width={16}>
        <br />
        <div style={{ marginTop: 15 }}>
          {itemsToReview.length > 0 ? (
            <div>
              {itemsToReview.map((company) => (
                <CompanyProfileListItem
                  company={company}
                  type={COMPANY_PROFILE_TYPE.underReview}
                  close={false}
                  key={company.id}
                />
              ))}
            </div>
          ) : (
            <span className="manage-item-list-no-item">None</span>
          )}
        </div>
      </Grid.Column>
    </Grid>
  );

  const panes = [
    {
      menuItem: `Review (${itemsToReview.length})`,
      render: () => <Tab.Pane>{REVIEW_TAB}</Tab.Pane>,
    },
  ];

  return <Tab panes={panes} renderActiveOnly={true} />;
}
